/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../../contexts/userContext";
import { AIRLINES, API_SAMPLES } from "../../../constants/appConstants";

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";
import UCDropzone from "../../ucdropzone";

/* Styles */
import styles from "./styles";

const InviteBulkCsvModal = ({showUploadModal, setShowUploadModal, getPendingInviteCount, dotsButtonItemRef}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const [isUploading, setIsUploading] = useState(false);
  const userContext = useUserContext();
  const providerCode = userContext?.userInfo?.providerInfo?.providerCode;

  const getApiSample = () => API_SAMPLES[providerCode] || "";

  const getTitle = () => {
    switch (providerCode) {
      case AIRLINES.CHOICE:
        return <FormattedMessage id="peopleHeader.modalUpload.titleCHOICE"/>
      default:
        return <FormattedMessage id="peopleHeader.modalUpload.title"/>
    }
  }
  const getDescription = () => {
    switch (providerCode) {
      case AIRLINES.CHOICE:
        return (
          <p className={classes.description}>
            <FormattedMessage id="peopleHeader.modalUpload.descriptionCHOICE" />
            <a href={getApiSample()} download="TravelerList.csv" target='_blank' className={classes.download}>
              <FormattedMessage id="peopleHeader.modalUpload.downloadCHOICE" />
            </a>
          </p>
        )
      default:
        return (
          <p className={classes.description}>
            <FormattedMessage id="peopleHeader.modalUpload.description" />
            <a href={getApiSample()} download="TravelerList.csv" target='_blank' className={classes.download}>
              <FormattedMessage id="peopleHeader.modalUpload.download" />
            </a>
            <FormattedMessage id="peopleHeader.modalUpload.description2" />
          </p>
        )
    }
  }
  return (
    <UCModal
      className={ `${classes.modal} ${isUploading ? classes.disableClose : ""}` }
      showModal={ showUploadModal }
      setShowModal={ setShowUploadModal }
      modalHeaderTitle={ getTitle() }
      modalDescription={ getDescription() }
      modalContent={
        <>
          <div className={classes.dropzone}>
            <UCDropzone
              setShowModal={setShowUploadModal}
              isUploading={isUploading}
              setIsUploading={setIsUploading}
              getPendingInviteCount={getPendingInviteCount}
              providerCode={providerCode}
            />
          </div>
        </>
      }
      dataTestId="deleteactionmodal"
      onExited={() => dotsButtonItemRef.current?.focus()}
    />
  )
}

export default InviteBulkCsvModal;
